import { render } from "./Radio.vue?vue&type=template&id=1dc22196&scoped=true&ts=true"
import script from "./Radio.vue?vue&type=script&lang=ts"
export * from "./Radio.vue?vue&type=script&lang=ts"

import "./Radio.vue?vue&type=style&index=0&id=1dc22196&lang=scss&scoped=true"

import exportComponent from "/var/www/html/drupal/modules/custom/nvschade_calculator/assets/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dc22196"]])

export default __exports__